import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Janela de páginas ao redor da atual + primeira/última sempre visíveis,
// com "..." pros buracos — evita uma fileira de 20+ botões quando há
// muitas páginas.
function gerarNumerosPagina(atual, total) {
  const janela = 1;
  const paginas = [];
  for (let p = 1; p <= total; p += 1) {
    if (p === 1 || p === total || (p >= atual - janela && p <= atual + janela)) {
      paginas.push(p);
    } else if (paginas[paginas.length - 1] !== '...') {
      paginas.push('...');
    }
  }
  return paginas;
}

// Controles de paginação centralizados, com números de página destacados
// (não só anterior/próxima) — reutilizado em toda tela com listagem
// paginada do painel.
const Paginacao = ({ pagina, totalPaginas, onMudarPagina, total, itensPorPagina }) => {
  if (totalPaginas <= 1) return null;
  const inicio = (pagina - 1) * itensPorPagina + 1;
  const fim = Math.min(pagina * itensPorPagina, total);
  const numeros = gerarNumerosPagina(pagina, totalPaginas);

  return (
    <div className="flex flex-col items-center gap-2.5 mt-8">
      <div className="flex items-center gap-1.5">
        <button
          onClick={() => onMudarPagina(pagina - 1)}
          disabled={pagina === 1}
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300 disabled:opacity-30 disabled:hover:bg-white disabled:hover:border-gray-200 transition-colors shadow-sm"
          aria-label="Página anterior"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>

        {numeros.map((n, i) => (
          n === '...' ? (
            <span key={`ellipsis-${i}`} className="w-9 h-9 flex items-center justify-center text-gray-400 text-sm select-none">…</span>
          ) : (
            <button
              key={n}
              onClick={() => onMudarPagina(n)}
              className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-semibold transition-colors ${
                n === pagina
                  ? 'bg-primary-600 text-white shadow-sm'
                  : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300'
              }`}
              aria-label={`Ir para página ${n}`}
              aria-current={n === pagina ? 'page' : undefined}
            >
              {n}
            </button>
          )
        ))}

        <button
          onClick={() => onMudarPagina(pagina + 1)}
          disabled={pagina === totalPaginas}
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300 disabled:opacity-30 disabled:hover:bg-white disabled:hover:border-gray-200 transition-colors shadow-sm"
          aria-label="Próxima página"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
      <p className="text-xs text-gray-400">Mostrando {inicio}–{fim} de {total}</p>
    </div>
  );
};

export default Paginacao;
